import { render, staticRenderFns } from "./AdditionalAssetAssign.vue?vue&type=template&id=aa08bab8&"
import script from "./AdditionalAssetAssign.vue?vue&type=script&lang=js&"
export * from "./AdditionalAssetAssign.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalAssetAssign.vue?vue&type=style&index=0&id=aa08bab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports